const CallToActionSchema = {
  title: 'Call To Action',

  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [
        'layout',
        'backgroundImage',
        'title',
        'text',
        'actions',
      ],
    },
  ],

  properties: {
    layout: {
      title: 'Layout Variant',
      type: 'string',
      default: 'variant1',
      choices: [
        ['variant1', 'Variant 1'],
        ['variant2', 'Variant 2'],
      ],
    },
    backgroundImage: {
      title: 'Background Image',
      type: 'string',
      widget: 'image',
    },
    title: {
      type: 'string',
      title: 'Title',
    },
    text: {
      type: 'string',
      widget: 'textarea',
      title: 'Text',
    },

    actions: {
      title: 'Buttons',
      description: 'Add up to 2 CTA buttons',
      type: 'array',
      maxItems: 2,
      widget: 'object_list',
      schema: {
        title: 'Action',
        fieldsets: [
          {
            id: 'default',
            title: 'Default',
            fields: [
              'variant', 
              'label',
              'link'
            ],
          },
        ],
        properties: {
          variant: {
            title: 'Style',
            type: 'string',
            default: 'primary',
            choices: [
              ['primary', 'Primary'],
              ['secondary', 'Secondary'],
            ],
          },
          label: {
            title: 'Button Text',
            type: 'string',
          },
          link: {
            title: 'Link',
            widget: 'object_browser',
            mode: 'link',
            selectableTypes: ['Document'],
          },
          icon: {
            title: 'Icon',
            type: 'string',
            description: 'Accepts any Semantic UI icon name'
          },
        },
      },
    },
  },

  required: [],
};

export default CallToActionSchema;